import React from 'react';
import { Icon, IconName } from '@hills-design-system/components';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  actionText?: string;
  onActionClick?: () => void;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  actionText,
  onActionClick,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-heading-200 leading-heading font-bold text-gray-925">{title}</h2>
        {subtitle && (
          <p className="text-heading-200 font-bold text-black text-opacity-60">{subtitle}</p>
        )}
      </div>
      {actionText && (
        <button
          className="flex items-center text-blue-600 font-medium hover:underline"
          onClick={onActionClick}
        >
          <span>{actionText}</span>
          <Icon icon={IconName.ArrowRight} size={24} />
        </button>
      )}
    </div>
  );
};
export default SectionTitle;
